import { useState } from 'react';

export const useFetching = (callback) => {
    const [isLoading, setIsLoading] = useState(false);
    const fetching = async (...args) => {
        setIsLoading(true);
        try {
            await callback(...args);
        } finally {
            setIsLoading(false);
        }
    };
    return [fetching, isLoading];
}; 